/**
 * The toast and error-message helpers the job posting pages all used to copy:
 * a 3 second toast, and the message from a rejected store action (the axios
 * response, see utils/storeHelpers.js) with a fallback.
 */
export default {
  methods: {
    showToast(title, message, variant = 'success') {
      this.$bvToast.toast(message, { title, autoHideDelay: 3000, variant })
    },

    errorMessage(err, fallback = 'Something went wrong.') {
      return (
        (err && err.data && err.data.message) ||
        (err && err.message) ||
        fallback
      )
    },

    onError(err, fallback) {
      this.showToast('Error', this.errorMessage(err, fallback), 'danger')
    },
  },
}
